module.exports = __webpack_public_path__ + "img/first-block-image.44b6bfc9.svg";